import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import InputText from "commons/ui/input/InputText";
import MobileDatePicker from "commons/ui/input/MobileDatePicker";
import SwitchInput from "commons/ui/input/SwitchInput";
import WysiwygSimpleEditor from "commons/ui/input/WysiwygSimpleEditor";
import Paper from "commons/ui/Paper";

import useWorkOfferForm from "hooks/form/useWorkOfferForm";

function WorkOfferForm() {
    const { datePickerHookFrom, formHook } = useWorkOfferForm();

    const { checkErrorVisibility, setValue, form } = formHook;

    return (
        <GridColumn>
            <Paper>
                <GridColumn>
                    <GridRow className={"title-margin"}>
                        <GridItem>
                            <h2>Impostazioni</h2>
                        </GridItem>
                    </GridRow>

                    <GridRow>
                        <GridItem className={"col-xs-24-10"}>
                            <MobileDatePicker datePickerHook={datePickerHookFrom} />
                        </GridItem>

                        <GridItem className={"col-xs-24-11"}>
                            <InputText
                                label={"Slug"}
                                value={form.slug}
                                setValue={setValue}
                                path={"slug"}
                                checkErrorVisibility={checkErrorVisibility}
                            />
                        </GridItem>

                        <GridItem className={"col-xs-24-3"}>
                            <SwitchInput
                                checked={form.enabled}
                                label={"Area pubblica"}
                                setValue={setValue}
                                path={"enabled"}
                                alignedToForm
                            />
                        </GridItem>
                    </GridRow>

                    <GridRow className={"title-margin"}>
                        <GridItem>
                            <h2>Testo</h2>
                        </GridItem>
                    </GridRow>

                    <GridRow>
                        <GridItem className={"col-xs-12-12"}>
                            <InputText
                                label={"Titolo"}
                                setValue={setValue}
                                value={form.text.it.title}
                                path={"text.it.title"}
                                checkErrorVisibility={checkErrorVisibility}
                            />
                        </GridItem>
                    </GridRow>

                    <GridRow>
                        <GridItem className={"col-xs-12-12"}>
                            <WysiwygSimpleEditor
                                label={"Descrizione corta"}
                                bigDefault={true}
                                value={form.text.it.short_description}
                                path={"text.it.short_description"}
                                setValue={setValue}
                                checkErrorVisibility={checkErrorVisibility}
                            />
                        </GridItem>
                    </GridRow>

                    <GridRow>
                        <GridItem className={"col-xs-12-12"}>
                            <WysiwygSimpleEditor
                                label={"Descrizione completa"}
                                bigDefault={true}
                                value={form.text.it.full_description}
                                path={"text.it.full_description"}
                                setValue={setValue}
                                checkErrorVisibility={checkErrorVisibility}
                            />
                        </GridItem>
                    </GridRow>
                </GridColumn>
            </Paper>
        </GridColumn>
    );
}

export default WorkOfferForm;
